/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  Form,
  Button,
  Row,
  Col,
  Spin,
  Input,
  Card,
  Tabs,
  // TreeSelect,
} from 'antd';
import {
  CheckCircleOutlined, FallOutlined, InfoCircleOutlined, MenuUnfoldOutlined,
  RiseOutlined,
  // SearchOutlined,
  // SnippetsOutlined,
} from '@ant-design/icons';
import { formatReceived } from 'utils/formatValues';
import { onError } from 'utils/handlers';
import Select from 'components/Select';
import {
  // getAreas,
  getMeses,
} from 'api/catalogos/index';
import {
  // normalizeDataAreas,
  // formatTreeSelectData,
  CRUDIncidenciaClock,
} from 'api/configuraciones/clock/IncidenciasReloj/IncidenciaValidacion';
import { checkToken } from 'api/utils';
import {
  ESTATUS_ACTIVO,
  ESTATUS_AUTORIZADO,
} from 'utils/constants';
import { getPeriodosFiscales } from 'api/configuraciones/periodosFiscales';
import moment from 'moment';
// import { getEvaluacionesAsistencia } from 'api/catalogos/TiposDeEvaluacionAsistencia';
import TabPane from 'antd/lib/tabs/TabPane';
// import { getTiposDeEmpleados } from 'api/catalogos/tiposDeEmpleados';
// import { getPlaza } from 'api/catalogos/plazas';
// import { getEmpleadosConDatosOpFilteredPaginated } from 'api/estructuraOrganizacional/empleados';
// import CustomSearch from 'components/customSearch';
// import FormSubmitControls from 'components/FormSubmitControls';
import { obtenerRegistrosDe } from 'utils/URIsSac';
import FormSubmitControls from 'components/FormSubmitControls';
import IncidenciaPreEliminarReloj from './IncidenciaPre_Eliminar';
import IncidenciaResumenReloj from './IncidenciaResumen';
import IncidenciaAutorizarReloj from './IncidenciaAutorizar';
import IncidenciaDescuento from './IncidenciaDescuentos';
import IncidenciaBonificaciones from './IncidenciaBonificaciones';

export const incidenciaRelojPermission = {
  permissionModel: 'cargadereportedetalle',
  catalogsModels: [],
  tabsModels: [],
};

const IncidenciasReloj = ({ permission }) => {
  const [form] = Form.useForm();
  // const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  // const [open, setVisible] = useState(false);
  // const [visibleAlert, setVisibleAlert] = useState(false);
  const [data, setData] = useState([]);
  const [dataResumen, setDataResumen] = useState([]);
  const [dataAutorizar, setDataAutorizar] = useState([]);
  const [dataDescuento, setDataDescuento] = useState([]);
  // const [incidencias, setIncidencias] = useState([]);
  const [periodosFiscales, setPeriodosFiscales] = useState([]);
  // const [selectedData, setSelectedData] = useState({});
  // const [visibleConfirmInactivo, setVisibleConfirmInactivo] = useState(false);
  // const [disableFields, setDisableFields] = useState(false);
  const [meses, setMeses] = useState([]);
  // const [areas, setAreas] = useState([]);
  // const [tiposEmpleados, setTiposEmpleados] = useState([]);
  // const [pageActual, setPageActual] = useState(1);
  const [currentParentTabKey, setCurrentParentTabKey] = useState('pre_eliminar');
  // const [baseURIPagination, setBaseURIPagination] = useState();
  // const [puestosPorEmpleado, setPuestosPorEmpleado] = useState({});
  // const [dataSearch, setDataSearch] = useState([]);
  // const [tiposDeNominaEmpleado, setTiposDeNominaEmpleado] = useState([]);
  // const [selectedEmpleadoSearch, setSelectedEmpleadoSearch] = useState();
  // const [openSearch, setVisibleSearch] = useState(false);
  // const [empleado, setEmpleado] = useState(null);

  const [visibleErrores, setVisibleErrores] = useState(false);
  const onErrors = () => {
    setVisibleErrores(true);
  };
  const [errores, setErrores] = useState([]);

  const urlPre_eliminar = '/relojchecador/cargas-de-reportes-detalles-vista-optimized/';
  const urlAutorizar = '/relojchecador/guardar-incidencia-vista-optimized/';
  const urlDescuentos = '/relojchecador/guardar-incidencia-vista-optimized/';

  const cliente = CRUDIncidenciaClock;

  const nameEmpleado = 'empleado';
  const criterioBusqueda = (is_preliminar = true) => {
    const _empleado = form.getFieldValue(nameEmpleado);
    const _mes = form.getFieldValue('mes');
    const _periodo_fiscal = form.getFieldValue('periodo_fiscal');
    const _directorio_areas = form.getFieldValue('directorio_areas');
    return ({
      ...(_empleado && { empleado_id: _empleado }),
      ...(_mes && { mes_id: _mes }),
      ...(_periodo_fiscal && { periodo_fiscal_id: _periodo_fiscal }),
      ...(_directorio_areas && { directorio_de_area_id: _directorio_areas }),
      ...(is_preliminar && { pre_eliminar: true }),
    });
  };
  const criterioBusquedaDescuento = () => {
    const _mes = form.getFieldValue('mes');
    const _periodo_fiscal = form.getFieldValue('periodo_fiscal');
    return ({
      ...(_mes && { mes: _mes }),
      // El endpoint '/relojchecador/evaluacion-cierre/' filtra por el nombre
      // real del campo FK ('periodo_fiscal'), no por 'periodo_fiscal_id'
      // (ese sufijo solo aplica a las vistas SQL "optimizadas" de otros tabs).
      ...(_periodo_fiscal && { periodo_fiscal: _periodo_fiscal }),
    });
  };

  const formInstances = [
    form,
  ];

  // let baseURIDatosOpPaginado =
  // 'catalogos/dato-operacional-del-empleado-paginado/?empleados_filter=';

  // const columnsEmpleado = [
  //   {
  //     titleText: 'No. de Empleado',
  //     dataIndex: 'empleado',
  //     key: 'empleado',
  //     width: 200,
  //     render: (empObject) => empObject?.numero_de_empleado,
  //   },
  //   {
  //     titleText: 'Nombre',
  //     dataIndex: 'empleado',
  //     key: 'empleado',
  //     width: 250,
  //     render: (empObject) => empObject?.nombre,
  //   },
  //   {
  //     titleText: 'Apellido Paterno',
  //     dataIndex: 'empleado',
  //     key: 'empleado',
  //     width: 250,
  //     render: (empObject) => empObject?.apellido_paterno,
  //   },
  //   {
  //     titleText: 'Apellido Materno',
  //     dataIndex: 'empleado',
  //     key: 'empleado',
  //     width: 250,
  //     render: (empObject) => empObject?.apellido_materno,
  //   },
  //   {
  //     titleText: 'Puesto',
  //     dataIndex: 'empleado',
  //     key: 'empleado',
  //     width: 300,
  //     render: (_, empObject) => puestosPorEmpleado[empObject.id],
  //   },
  //   {
  //     titleText: 'Tipo de Nómina Empleado',
  //     dataIndex: 'tipo_de_nomina_empleado',
  //     key: 'tipo_de_nomina_empleado',
  //     width: 250,
  //     render: (tneEmp) => tiposDeNominaEmpleado?.find((tne) => tne?.id === tneEmp)?.descripcion,
  //   },
  // ];
  // function buildEmisorFields(empleadoResult) {
  //   return {
  //     empleado: empleadoResult?.numero_y_nombre_completo,
  //   };
  // }
  // const findPuesto = async (empleados) => {
  //   const nuevosPuestos = {};
  //   await Promise.all(
  //     empleados.map(async (emp) => {
  //       try {
  //         const plazaEmp = await getPlaza(emp.plaza);
  //         nuevosPuestos[emp.id] = plazaEmp?.puesto_descripcion || '';
  //       } catch {
  //         nuevosPuestos[emp.id] = '';
  //       }
  //     }),
  //   );

  //   setPuestosPorEmpleado(nuevosPuestos);
  // };

  // const searchData = async (empId, nombreEmp, apPatEmp, apMatEmp, tipoNominaEmpleado) => {
  //   setLoading(true);
  //   if (empId) {
  //     baseURIDatosOpPaginado = `${baseURIDatosOpPaginado}numero_de_empleado=${empId};`;
  //   }
  //   if (nombreEmp) {
  //     baseURIDatosOpPaginado = `${baseURIDatosOpPaginado}nombre=${nombreEmp};`;
  //   }
  //   if (apPatEmp) {
  //     baseURIDatosOpPaginado = `${baseURIDatosOpPaginado}apellido_paterno=${apPatEmp};`;
  //   }
  //   if (apMatEmp) {
  //     baseURIDatosOpPaginado = `${baseURIDatosOpPaginado}apellido_materno=${apMatEmp};`;
  //   }
  //   if (tipoNominaEmpleado) {
  //     baseURIDatosOpPaginado =
  // `${baseURIDatosOpPaginado}&tipo_de_nomina_empleado=${tipoNominaEmpleado}&`;
  //   }
  //   setBaseURIPagination(baseURIDatosOpPaginado);
  //   const _empleados = await getEmpleadosConDatosOpFilteredPaginated(baseURIDatosOpPaginado);
  //   await findPuesto(_empleados.results);
  //   setDataSearch(_empleados);
  //   return setLoading(false);
  // };

  // const validateInput = async (field, setterFields) => {
  //   setLoading(true);
  //   setSelectedEmpleadoSearch();
  //   const searchEmp = form.getFieldValue(field);
  //   if (!searchEmp) {
  //     setVisibleSearch(true);
  //     return setLoading(false);
  //   }
  //   const res = await getEmpleadosConDatosOpFilteredPaginated(
  //     `${baseURIDatosOpPaginado}numero_de_empleado=${searchEmp};`,
  //   );

  //   const result = res?.results?.[0];

  //   if (!res) {
  //     return setLoading(false);
  //   }
  //   const empleadoResult = result?.empleado;
  //   if (empleadoResult) {
  //     const fields = setterFields(empleadoResult);
  //     form.setFieldsValue(fields);
  //     setEmpleado(empleadoResult?.id);
  //   } else {
  //     setEmpleado(null);
  //     form.resetFields([field]);
  //   }
  //   // onChangeEmpleado(empleadoResult?.id);
  //   return setLoading(false);
  // };

  const defineDateValues = (value, valueTime = 'month') => {
    if (!value || !moment.isMoment(value)) {
      form.setFieldValue('fecha_inicial', '');
      form.setFieldValue('fecha_final', '');
      return;
    }
    const firstDay = value.clone().startOf(valueTime);
    const lastDay = value.clone().endOf(valueTime);

    form.setFieldValue('fecha_inicial', firstDay.format('DD-MM-YYYY'));
    form.setFieldValue('fecha_final', lastDay.format('DD-MM-YYYY'));
  };

  /*
  const fetchDataGuardar = async () => {
    setLoading(true);
    const _data = await clienteGuardar.obtenerListaDeRegistros({
      ...criterioBusqueda(),
    });
    setData(formatReceived(filterByArea(_data)));
    setLoading(false);
  };
  */

  const fetchDataDescuento = async () => {
    setLoading(true);
    const is_preliminar = false;
    const _data = await obtenerRegistrosDe(urlDescuentos, {
      ...criterioBusqueda(is_preliminar),
    });
    setDataDescuento(_data);
    setLoading(false);
  };
  const fetchDataAutorizar = async () => {
    setLoading(true);
    const is_preliminar = false;
    const _data = await cliente.obtenerListaDeRegistros({
      ...criterioBusqueda(is_preliminar),
    }, urlAutorizar);
    setDataResumen(_data?.filter((e) => e?.autorizar === false));
    // `autorizar` es una bandera estática (se define al crear el registro y nunca
    // cambia), así que por sí sola no distingue lo pendiente de lo ya autorizado.
    // Se exige además `estado_global === ESTATUS_ACTIVO` para que, en cuanto un
    // registro se autoriza (pasa a ESTATUS_AUTORIZADO), desaparezca de este tab —
    // ya vive en el tab "Descuentos" vía su IncidenciaEmpleado generada.
    setDataAutorizar(
      _data?.filter((e) => e?.autorizar === true && e?.estado_global === ESTATUS_ACTIVO),
    );
    setLoading(false);
  };

  const fetchData = async () => {
    setLoading(true);
    const _data = await cliente.obtenerListaDeRegistros({
      ...criterioBusqueda(),
    }, urlPre_eliminar);
    setData(formatReceived(_data));
    setLoading(false);
  };

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        // _tiposIncidencias,
        // _areas,
        _periodosFiscales,
        _meses,
        // _tiposEmpleados,
      ] = await Promise.all([
        // getEvaluacionesAsistencia(),
        // getAreas(),
        getPeriodosFiscales({ estados_globales: ESTATUS_AUTORIZADO }),
        getMeses(),
        // getTiposDeEmpleados({ estados_globales: ESTATUS_AUTORIZADO }),
      ]);
      if (mounted) {
        const defaultYear = _periodosFiscales[_periodosFiscales.length - 1];
        const defaultDate = moment().year(defaultYear?.descripcion);
        form.setFieldValue('periodo_fiscal', defaultYear?.id);
        form.setFieldValue('mes', defaultDate.month() + 1);
        defineDateValues(defaultDate);

        // setIncidencias(_tiposIncidencias);
        // const formattedURS = formatTreeSelectData(normalizeDataAreas(_areas));
        // setAreas(formattedURS);
        setPeriodosFiscales(_periodosFiscales);
        setMeses(_meses);
        // setTiposEmpleados(_tiposEmpleados);
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
    // eslint-disable-next-line
  }, []);

  const onClickBuscar = async () => {
    try {
      await form.validateFields();
      setLoading(true);
      await fetchData();
      await fetchDataAutorizar();
      setLoading(false);
    } catch (err) {
      onError(
        err,
        setLoading,
        formInstances,
      );
    }
  };

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const rules = {
    required: [requiredRule],
  };

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Card
          className="form-container"
          bordered={false}
          extra={(
            <FormSubmitControls
              onErrors={errores?.results?.length ? onErrors : undefined}
            />
          )}
        >

          <Form
            layout="vertical"
            form={form}
            scrollToFirstError
            name="general"
            initialValues={{
              estados_globales: ESTATUS_ACTIVO,
            }}
          >
            <Row gutter={10}>
              <Col xs={24} sm={8}>
                <Form.Item
                  name="periodo_fiscal"
                  label="Año"
                  rules={rules.estatus}
                  hasFeedback
                >
                  <Select
                    dataSource={periodosFiscales}
                    onChange={(value) => {
                      const año = periodosFiscales.find((item) => item.id === value);
                      const date = moment().year(año?.descripcion);
                      defineDateValues(date);
                    }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={8}>
                <Form.Item
                  name="fecha_inicial"
                  label="Fecha Inicial"
                >
                  <Input
                    allowClear
                    disabled
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={8}>
                <Form.Item
                  name="fecha_final"
                  label="Fecha Final"
                >
                  <Input
                    allowClear
                    disabled
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={8}>
                <Form.Item
                  name="mes"
                  label="Mes"
                  rules={rules.estatus}
                  hasFeedback
                >
                  <Select
                    labelProp="nombre"
                    keyProp="id"
                    dataSource={meses}
                    onChange={(value) => {
                      let date = moment().month(value - 1);
                      let timeValue = 'month';
                      if (!value) {
                        const year = form.getFieldValue('periodo_fiscal');
                        const año = periodosFiscales.find((item) => item.id === year);
                        date = moment().year(año?.descripcion);
                        timeValue = 'year';
                      }
                      defineDateValues(date, timeValue);
                    }}
                  />
                </Form.Item>
              </Col>
              {/*
              <Col xs={24} sm={8}>
                <Form.Item
                  name="incidencia"
                  label="Tipo de Incidencia"
                  rules={rules.estatus}
                  hasFeedback
                >
                  <Select
                    labelProp="nombre"
                    keyProp="id"
                    dataSource={incidencias}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={8}>
                <Form.Item
                  name="directorio_areas"
                  label="Área"
                  rules={rules.estatus}
                  hasFeedback
                >
                  <TreeSelect
                    showSearch
                    allowClear
                    treeNodeFilterProp="title"
                    treeData={areas}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8}>
                <Form.Item
                  name={nameEmpleado}
                  label="No. y Nombre del Empleado"
                  required
                  hasFeedback
                >
                  <Select
                    labelProp="numero_y_nombre_completo"
                    dataSource={empleados}
                    disabled={selectedRowKeys?.length}
                  />
                </Form.Item>
              </Col>
              */}
            </Row>
            <Col xs={24}>
              <Form.Item>
                <Button
                  onClick={() => onClickBuscar()}
                >
                  Buscar
                </Button>
              </Form.Item>
            </Col>
          </Form>
          <Tabs
            type="card"
            activeKey={currentParentTabKey || 'pre_eliminar'} // Evitar undefined
            onChange={setCurrentParentTabKey}
          >
            <TabPane
              tab={(
                <span>
                  <MenuUnfoldOutlined />
                  {' '}
                  Pre-Eliminar
                </span>
              )}
              key="pre_eliminar"
              forceRender
            >
              <IncidenciaPreEliminarReloj
                permission={permission}
                parent_data={data}
              />
            </TabPane>
            <TabPane
              tab={(
                <span>
                  <InfoCircleOutlined />
                  {' '}
                  Resumen
                </span>
              )}
              key="resumen"
              forceRender
            >
              <IncidenciaResumenReloj
                permission={permission}
                parent_data={dataResumen}
              />
            </TabPane>
            <TabPane
              tab={(
                <span>
                  <CheckCircleOutlined />
                  {' '}
                  Autorizar
                </span>
              )}
              key="autorizar"
              forceRender
            >
              <IncidenciaAutorizarReloj
                permission={permission}
                parent_data={dataAutorizar}
                fetchData={fetchDataAutorizar}
                errorsVisibleEffect={[visibleErrores, setVisibleErrores]}
                errorsEffect={[errores, setErrores]}
              />
            </TabPane>
            <TabPane
              tab={(
                <span>
                  <FallOutlined />
                  {' '}
                  Descuentos
                </span>
              )}
              key="Descuentos"
              forceRender
            >
              {/** solo va a mostrar la tabla, pero no quito todo, por si las dudas
               * (a cada rato cambian de idea) */}
              {/** se puede optimizar mas */}
              <IncidenciaDescuento
                parametroBusqueda={criterioBusquedaDescuento()}
                permission={permission}
                activeTabKey={currentParentTabKey}
              />
            </TabPane>
            <TabPane
              tab={(
                <span>
                  <RiseOutlined />
                  {' '}
                  Bonificaciones
                </span>
              )}
              key="Bonificaciones"
              forceRender
            >
              <IncidenciaBonificaciones
                parametroBusqueda={criterioBusquedaDescuento()}
                permission={permission}
                activeTabKey={currentParentTabKey}
              />
            </TabPane>
          </Tabs>
        </Card>
      </Spin>
    </Row>
  );
};

export default IncidenciasReloj;
